import { IAction } from 'src/typings';
import { ITypeDisplayedSpinner } from 'src/store/type-displayed-spinner/types';
import { ActionTypes } from './actions';

export const initialState: ITypeDisplayedSpinner = {
  listOfTypes: [],
  selectedView: '',
  initialViewRouteResolved: false,
};

export const typeDisplayedSpinnerReducer = (
  state = initialState,
  { type, payload }: IAction,
): ITypeDisplayedSpinner => {
  switch (type) {
    case ActionTypes.SET_TYPE_DISPLAYED_SPINNER:
      return {
        ...state,
        selectedView: payload,
      };
    case ActionTypes.SET_LIST_TYPES_SUCCESS:
      return {
        ...state,
        listOfTypes: payload,
        initialViewRouteResolved: false,
      };
    case ActionTypes.SET_INITIAL_VIEW_ROUTE_RESOLVED:
      return {
        ...state,
        initialViewRouteResolved: payload,
      };

    default:
      return state;
  }
};
